import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { Variables } from "../../Variations/Variations";
import { BiStore, BiEdit, BiShowAlt, BiHide, BiTrash } from "react-icons/bi";
import { FaStoreSlash } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import Util from "../../Classes/Util";
import { AiOutlineClose, AiOutlineCheck, AiOutlineRight } from 'react-icons/ai'
import { MdManageSearch } from "react-icons/md";
import Cookies from "js-cookie";

const ListProducts = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(
    parseInt(searchParams.get("page")) || 1
  );
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [pendingSearch, setPendingSearch] = useState("");
  const [listProducts, setProducts] = useState();
  const permissions = Util.decrypt(localStorage.getItem("Permissions"));
  const [checkedProducts, setCheckedProducts] = useState([]);
  const [show, setShow] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [images, setImages] = useState([]);
  const [filterBy, setFilterBy] = useState(0);
  const [isOpenDelete, setIsOpenDelete] = useState(0);
  const [isOpenDeleteAll, setIsOpenDeleteAll] = useState(false);
  const [productVariations, setProductVariations] = useState([])
  const navigate = useNavigate();

  function handleProducts(e, ProductId) {
    var updatedList = [...checkedProducts];

    if (e.target.checked) {
      updatedList = [...updatedList, { ProductId: ProductId }];
    } else {
      updatedList = updatedList.filter((item) => item.ProductId != ProductId);
    }
    setCheckedProducts(updatedList);
    if (updatedList.length !== 0) {
      setShow(true);
    } else {
      setShow(false);
    }
    updatedList = [];
  }
  const handleInStock = async () => {
    const token = Cookies.get("UserToken");
    let response = await fetch(Variables.API_URL + "Products/UpdateToInStock", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": Variables.API_URL,
      },
      body: JSON.stringify(
        checkedProducts.map((item) => ({
          ProductId: item.ProductId,
        }))
      ),
    });
    let result = await response.json();
    if (response.ok) {
      toast.success(result);
      setShow(false);
      setCheckedProducts([]);
      setCheckAll(false);
    } else {
      toast.error("Please Check With Administrator");
    }
  };
  const handleOutOfStock = async () => {
    const token = Cookies.get("UserToken");
    let response = await fetch(
      Variables.API_URL + "Products/UpdateToOutOfStock",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": Variables.API_URL,
        },
        body: JSON.stringify(
          checkedProducts.map((item) => ({
            ProductId: item.ProductId,
          }))
        ),
      }
    );
    let result = await response.json();
    if (response.ok) {
      toast.success(result);
    } else {
      toast.error("Please Check With Administrator");
    }
    setShow(false);
    setCheckedProducts([]);
    setCheckAll(false);
  };
  const handleOnBackorder = async () => {
    const token = Cookies.get("UserToken");
    let response = await fetch(
      Variables.API_URL + "Products/UpdateToBakcorder",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": Variables.API_URL,
        },
        body: JSON.stringify(
          checkedProducts.map((item) => ({
            ProductId: item.ProductId,
          }))
        ),
      }
    );
    let result = await response.json();
    if (response.ok) {
      toast.success(result);
    } else {
      toast.error("Please Check With Administrator");
    }
    setShow(false);
    setCheckedProducts([]);
    setCheckAll(false);
  };

  const handleDeleteProducts = async () => {
    const token = Cookies.get("UserToken");
    let response = await fetch(Variables.API_URL + "Products/DeleteProducts", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": Variables.API_URL,
      },
      body: JSON.stringify(
        checkedProducts.map((item) => ({
          ProductId: item.ProductId,
        }))
      ),
    });
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result);
    } else {
      toast.error("Please Check With Administrator");
    }
    setShow(false);
    setCheckedProducts([]);
    setCheckAll(false);
  };
  const handlePublishAll = async () => {
    const token = Cookies.get("UserToken");
    let response = await fetch(
      Variables.API_URL + "Products/TogglePublishAllProducts",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": Variables.API_URL,
        },
        body: JSON.stringify(
          checkedProducts.map((item) => ({
            ProductId: item.ProductId,
          }))
        ),
      }
    );
    let result = await response.json();
    if (response.ok) {
      const currentPage = parseInt(searchParams.get("page")) || 1;
loadProducts(currentPage, pageSize);
      setShow(false);
      setCheckedProducts([]);

      setCheckAll(false);
      toast.success(result);
    } else {
      toast.error("Please Check With Administrator");
    }
  };

  const handleUnPublishAll = async () => {
    const token = Cookies.get("UserToken");
    let response = await fetch(
      Variables.API_URL + "Products/ToggleUnPublishAllProducts",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": Variables.API_URL,
        },
        body: JSON.stringify(
          checkedProducts.map((item) => ({
            ProductId: item.ProductId,
          }))
        ),
      }
    );
    let result = await response.json();
    if (response.ok) {
      const currentPage = parseInt(searchParams.get("page")) || 1;
loadProducts(currentPage, pageSize);
      setShow(false);
      setCheckedProducts([]);

      setCheckAll(false);
      toast.success(result);
    } else {
      toast.error("Please Check With Administrator");
    }
  };

  function handleAllProducts(e) {
    setCheckAll(e.target.checked);
    var array = [];
    var obj = {};

    for (var i = 0; i < filteredList.length; i++) {
      obj = { ProductId: filteredList[i].ProductId };
      array.push(obj);
      if (e.target.checked) {
        setCheckedProducts(array);
        setShow(true);
      }
      else {
        setCheckedProducts([])
        setShow(false)
      }
    }
  }

  const columns = [

    {
      name: (
        <div className="form-check" style={{ width: "15px" }}>
          <input
            className="form-check-input"
            type="checkbox"
            id="flexCheckDefault"
            onChange={(e) => handleAllProducts(e)}
            value={checkAll}
            checked={checkAll}
          />

        </div>
      ),
      selector: (row) => (
        <div style={{ width: "15px" }}>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="flexCheckDefault"
              value={row.ProductId}
              onChange={(e) => handleProducts(e, row.ProductId)}
              checked={
                checkedProducts.filter(
                  (value) => value.ProductId === row.ProductId
                ).length !== 0
                  ? checkedProducts.filter(
                    (value) => value.ProductId === row.ProductId
                  )[0].ProductId
                  : 0
              }
            />
          </div>
        </div>
      ),

    },
    {
      name: "ID",
      selector: (row) => <label> {row.ProductId}</label>,



    },
    {
      name: "Image",
      selector: (row) => (
        <>
          {row.ProductTypeId == 2 ? (
            <img
              src={
                Variables.API_PUBLISHED +
                images
                  .filter((child) => child.ProductId == row.ProductId)
                  .map((c) => c.Image)
              }
              style={{ width: "100px", padding: "5px" }}
            />
          ) : (
            <img
              src={Variables.API_PUBLISHED + row.ProductImage}
              style={{ width: "100px", padding: "5px" }}
            />
          )}
        </>
      ),

    },
    {
      name: (
        <>
          <label> Product Name </label>
          {/* <input
            type="text"
            placeholder="Search By Product Name"
            onChange={(e) => handleSearchByProductName(e)}
          /> */}
        </>
      ),
      selector: (row) => row.ProductName,

    },
    {
      name: (
        <>
          <label> SKU</label>
          {/* <input
            type="text"
            placeholder="Search By SKU"
            onChange={(e) => handleSearchBySku(e)}
          /> */}
        </>
      ),
      selector: (row) => row.Sku,

    },
    {
      name: "Short Description ",
      selector: (row) => row.SmallDescription,


    },
    {
      name: "Variations ",
      selector: (row) => row.VariationCount,


    },
    {
      name: "Published",
      cell: (row) => row.IsPublished ? <AiOutlineCheck /> : <AiOutlineClose />,
      center: true
    },
    {
      name: "Options",
      selector: (row) => (
        <div>
          {permissions.PublishProduct === true ? (
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => TooglePublishProduct(row.ProductId)}
            >
              {row.IsPublished ? <BiHide /> : <BiShowAlt />}{" "}
            </button>
          ) : null}
          {permissions.ManageProduct === true ? (
            <NavLink
              to={`/Products/${row.ProductId}?page=${page}`}
              className="btn btn-outline-warning btn-sm ms-2"
            >
              <BiEdit />
            </NavLink>
          ) : null}
          {/* {permissions.DeleteProduct === true ? (
            <button
              className="btn btn-outline-danger btn-sm ms-2"
              onClick={() => setIsOpenDelete(row.ProductId)}
            >
              <BiTrash />
            </button>
          ) : null} */}
          <Modal
            show={row.ProductId === isOpenDelete}
            onHide={() => setIsOpenDelete(0)}
          >
            <Modal.Header>
              <Modal.Title>Delete Request</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="container">
                <div className="row">
                  <p>
                    Are you sure you want to
                    <b> Delete</b> the product named <b>{row.ProductName}</b>?
                  </p>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="container">
                <div className="row">
                  <div className="col-8"></div>
                  <div className="col-2">
                    <Button
                      variant="primary"
                      className="form-control"
                      onClick={() => DeleteProduct(row.ProductId)}
                    >
                      Yes
                    </Button>
                  </div>
                  <div className="col-2">
                    <Button
                      variant="secondary"
                      className="form-control"
                      onClick={() => setIsOpenDelete(0)}
                    >
                      No
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Footer>
          </Modal>
        </div>
      ),

    },
  ];
  const variationColumns = [

    {
      name: "ID",
      selector: (row) => row.ProductVariationId,
      sortable: true,


    },
    {
      name: "Image",
      selector: (row) => <img
        src={Variables.API_PUBLISHED + row.Image}
        style={{ width: "100px", padding: "5px" }}
      />,

    },
    {
      name: "Description",
      selector: (row) => row.Description,

    },
    {
      name: "Sku",
      selector: (row) => row.Sku,

    },
    {
      name: "Color",
      selector: (row) => row.Color,

    },
    {
      name: "Size",
      selector: (row) => row.Size,

    },
    {
      name: "Sale Price ",
      selector: (row) => row.SalePrice,
    },
    {
      name: "Regular Price ",
      selector: (row) => row.RegularPrice,


    },
  ];

  async function fetchProductVariations(e, row) {
    const token = Cookies.get("UserToken");
    if (e == true) {
      const URL =
        Variables.API_URL +
        "Products/GetProductVariationsForDataTable/" +
        row.ProductId;
      const response = await fetch(URL, {
        method: "Get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
          "Access-Control-Allow-Origin": Variables.API_URL,
        },
      });
      if (!response.ok) throw Error("Did Not Receive expected data");
      const listItems = await response.json();
      var array = [...listProducts];
      array.forEach((element, i) => {
        if (element.ProductId === row.ProductId) {
          delete array[i].Variations;
          array[i].Variations = listItems
        }
      });
      setFilteredList(array);
      setProducts(array);
    }
  }
  const ExpandedComponent = ({ data }) => <DataTable className="productList" columns={variationColumns} data={data.Variations} />;


  async function DeleteProduct(id) {
    const token = Cookies.get("UserToken");
    let response = await fetch(
      Variables.API_URL + "Products/DeleteProduct/" + id,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": Variables.API_URL,
        },
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result);
      const currentPage = parseInt(searchParams.get("page")) || 1;
loadProducts(currentPage, pageSize);
    } else {
      toast.error("Please check with administrator");
    }
  }

  async function TooglePublishProduct(id) {
    const token = Cookies.get("UserToken");
    let response = await fetch(
      Variables.API_URL + "Products/TooglePublishProduct/" + id,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "https://api.playmegastorelb.com/api/",
        },
      }
    );
    let result = await response.json();
    if (response.ok) {
      toast.success(result);
     const currentPage = parseInt(searchParams.get("page")) || 1;
loadProducts(currentPage, pageSize);
    } else {
      toast.error(result);
    }
  }

  async function loadProducts(
    p = page,
    s = pageSize,
    search = searchText
  ) {
    const token = Cookies.get("UserToken");

    const URL =
      Variables.API_URL +
      `Products/GetProductsPaged?page=${p}&pageSize=${s}&search=${search ?? ""}`;

    const response = await fetch(URL, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });

    if (!response.ok) throw Error("Failed to load products");

    const result = await response.json();

    setProducts(result.Data);
    setFilteredList(result.Data);
    setTotalRows(result.Total);
    setPage(p);
    setPageSize(s);
  }



  //#region Use Effect
  useEffect(() => {
    if (Cookies.get("UserToken") == undefined) {
      navigate("/Login");
    } else {
      const currentPage = parseInt(searchParams.get("page")) || 1;
loadProducts(currentPage, pageSize);
    }
  }, []);

  //#endregion Use Effect
  return (
    <div className="rightSide">
      <div className="container-fluid mt-3">
        <div className="row">
          <div className="col-12">
            <h2>List Products</h2>
            <ul className="portalPath">
              <li>Home <AiOutlineRight /></li>
              <li>List Products</li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              {/* <div className="card-header">
                <div className="row">
                  <div className="col-lg-6">
                    <h3>List Products</h3>
                  </div>

                  <div
                    className="col-lg-6 text-right"
                  >
                    {permissions.ManageProduct === true ? (
                      <NavLink to="/Products/0" className="btn btn-primary">
                        Add Product
                      </NavLink>
                    ) : null}
                  </div>
                </div>
              </div> */}
              <div className="card-body">
                <div className="row mb-3 align-items-center">
                  {/* SEARCH */}
                  <div className="col-md-8">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search products..."
                        value={pendingSearch}
                        onChange={(e) => setPendingSearch(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            setSearchText(pendingSearch);
                            loadProducts(1, pageSize, pendingSearch);
                          }
                        }}
                      />
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => {
                          setSearchText(pendingSearch);
                          loadProducts(1, pageSize, pendingSearch);
                        }}
                      >
                        Search
                      </button>
                    </div>
                  </div>

                  {/* ADD BUTTON */}
                  <div className="col-md-4 text-end">
                    {permissions.ManageProduct === true ? (
                      <NavLink to="/Products/0" className="btn btn-primary">
                        Add Product
                      </NavLink>
                    ) : null}
                  </div>
                </div>
                {/* <div className="row">
                  <div
                    className="col-12 text-end"
                  >
                    {permissions.ManageProduct === true ? (
                      <NavLink to="/Products/0" className="btn btn-primary">
                        Add Product
                      </NavLink>
                    ) : null}
                  </div>
                </div> */}
                <div className="row">
                  <div className="col-12">
                    <div className="row" style={{ margin: "10px" }}>
                      {show === true ? (
                        <>
                          {permissions.SetInStock && (<div className="col-2">
                            <label>
                              <button
                                className="btn btn-primary"
                                onClick={handleInStock}
                              >
                                {" "}
                                In Stock <BiStore />
                              </button>{" "}
                            </label>
                          </div>)}
                          {permissions.SetOutOfStock && (
                            <div className="col-2">
                              <label>
                                {" "}
                                <button
                                  className="btn btn-primary"
                                  onClick={handleOutOfStock}
                                >
                                  {" "}
                                  Out of Stock <FaStoreSlash />
                                </button>{" "}
                              </label>
                            </div>)}
                          {permissions.SetOnBackorder && (<div className="col-2">
                            <label>
                              <button
                                className="btn btn-primary"
                                onClick={handleOnBackorder}
                              >
                                On Backorder <BiStore />
                              </button>{" "}
                            </label>
                          </div>)}

                          {permissions.PublishProduct && (
                            <>
                              <div className="col-2">
                                <label>
                                  <button
                                    className="btn btn-primary"
                                    onClick={handlePublishAll}
                                  >
                                    {" "}
                                    Publish <BiEdit />
                                  </button>{" "}
                                </label>
                              </div>
                              <div className="col-2">
                                {" "}
                                <label>
                                  <button
                                    className="btn btn-primary"
                                    onClick={handleUnPublishAll}
                                  >
                                    {" "}
                                    UnPublish <BiEdit />
                                  </button>{" "}
                                </label>
                              </div>
                            </>)}
                          <div className="col-2">
                            {permissions.DeleteProduct === true ? (
                              <label>
                                {" "}
                                <button
                                  className="btn btn-danger"
                                  onClick={() => setIsOpenDeleteAll(true)}
                                >
                                  Delete <BiTrash />
                                </button>{" "}
                              </label>
                            ) : null}
                            <Modal
                              show={isOpenDeleteAll}
                              onHide={() => setIsOpenDeleteAll(0)}
                            >
                              <Modal.Header>
                                <Modal.Title>Delete Request</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <div className="container">
                                  <div className="row">
                                    <p>
                                      Are you sure you want to
                                      <b> Delete </b> all selected <b> Products</b> ?
                                    </p>
                                  </div>
                                </div>
                              </Modal.Body>
                              <Modal.Footer>
                                <div className="container">
                                  <div className="row">
                                    <div className="col-8"></div>
                                    <div className="col-2">
                                      <Button
                                        variant="primary"
                                        className="form-control"
                                        onClick={() => handleDeleteProducts()}
                                      >
                                        Yes
                                      </Button>
                                    </div>
                                    <div className="col-2">
                                      <Button
                                        variant="secondary"
                                        className="form-control"
                                        onClick={() => setIsOpenDeleteAll(0)}
                                      >
                                        No
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              </Modal.Footer>
                            </Modal>
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-12 productList">
                    <div className="portalTable">
                      <DataTable
                        columns={columns}
                        data={filteredList}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={pageSize}
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                        onRowExpandToggled={(e, row) => fetchProductVariations(e, row)}
                        paginationDefaultPage={page}
  onChangePage={(p) => {
    setSearchParams({ page: p });
    loadProducts(p, pageSize);
  }}
  onChangeRowsPerPage={(s, p) => {
    setSearchParams({ page: p });
    loadProducts(p, s);
  }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
        />
      </div>
    </div>
  );
};
export default ListProducts;
